import { useNavigate } from "react-router";
import { useAuth } from "../../Contexts/AuthContext";
import { EditUserDataType } from "../../Enums/EditUserDataType";
import { toPublicPath } from "../../Utils/publicRoutes";
import { FaCheck, FaTimes } from "react-icons/fa";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

type EditUserDataInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  method?: EditUserDataType;
};

const EditUserDataInfoModal = ({ isOpen, onClose, method }: EditUserDataInfoModalProps) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate(toPublicPath("/login"));
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl px-6 py-9 relative w-full max-w-3xl">
        <button 
          onClick={handleLogout} 
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
        >
          <FaTimes />
        </button>

        <div className="flex flex-col items-center justify-center gap-4">
          <FaCheck className="text-primary-600 text-xl" />
          
          <h4 className="text-lg font-bold">
            {method === EditUserDataType.Email && "E-MAIL ALTERADO!"}
            {method === EditUserDataType.Password && "SENHA ALTERADA!"}
          </h4>

          <div className="w-full flex flex-col items-center justify-center gap-2">
            {method === EditUserDataType.Email &&
              <p>{"Seu e-mail foi alterado com sucesso!"}</p>
            }

            {method === EditUserDataType.Password &&
              <p>{"Sua senha foi alterada com sucesso!"}</p>
            }

            <p>{"Agora você já pode continuar a sua navegação!"}</p>
      
            <Button 
              onClick={handleLogout} 
              className="block mx-auto px-16 py-2"
            >
              {"CONTINUAR"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditUserDataInfoModal;
